import axios from "axios";

// const
const REDIRECT_TO_APPLICATION_MARKET_LIST = "applicationMarketList/REDIRECT_TO_APPLICATION_MARKET_LIST";
const APPLICATION_MARKET_LIST_STORE_PARENT_CATEGORIES = "applicationMarketList/APPLICATION_MARKET_LIST_STORE_PARENT_CATEGORIES";
const APPLICATION_MARKET_LIST_STORE_SECOND_CATEGORIES = "applicationMarketList/APPLICATION_MARKET_LIST_STORE_SECOND_CATEGORIES";
const APPLICATION_MARKET_LIST_STORE_APPLICATIONS = "applicationMarketList/APPLICATION_MARKET_LIST_STORE_APPLICATIONS";
const APPLICATION_MARKET_LIST_STORE_PAGE = "applicationMarketList/APPLICATION_MARKET_LIST_STORE_PAGE";
const APPLICATION_MARKET_LIST_UPDATE_DATA = "applicationMarketList/APPLICATION_MARKET_LIST_UPDATE_DATA";
const APPLICATION_MARKET_LIST_TOGGLE_LOADING = "applicationMarketList/APPLICATION_MARKET_LIST_TOGGLE_LOADING";

// reducer
export const applicationMarketList = (state = {
  loading: false,
  pageSize: 10,
  pageCurrent: 1,
  pageTotal: 0,

  name: "",
  parentCategories: [],
  parentCategory: "",
  secondCategories: [],
  secondCategory: "",
  releaseType: "",
  minCost: -1,
  maxCost: -1,
  minCostCustom: -1,
  maxCostCustom: -1,
  applications: [],

  applicationId: "",
}, action) => {
  switch (action.type) {
    case REDIRECT_TO_APPLICATION_MARKET_LIST:
      return {
        ...state,
        name: action.data.name,
        parentCategory: action.data.parentCategory,
        secondCategory: action.data.secondCategory
      };
    case APPLICATION_MARKET_LIST_STORE_PARENT_CATEGORIES:
      return {
        ...state,
        parentCategories: action.data
      };
    case APPLICATION_MARKET_LIST_STORE_SECOND_CATEGORIES:
      return {
        ...state,
        secondCategories: action.data
      };
    case APPLICATION_MARKET_LIST_STORE_APPLICATIONS:
      return {
        ...state,
        applications: action.data
      };
    case APPLICATION_MARKET_LIST_STORE_PAGE:
      return {
        ...state,
        pageCurrent: action.data.pageCurrent + 1,
        pageTotal: action.data.pageTotal,
        name: action.data.name,
        parentCategory: action.data.parentCategory,
        secondCategory: action.data.secondCategory,
        releaseType: action.data.releaseType,
        minCost: action.data.minCost,
        maxCost: action.data.maxCost,
      };
    case APPLICATION_MARKET_LIST_UPDATE_DATA:
      return {
        ...state,
        [action.data.name]: action.data.value
      };
    case APPLICATION_MARKET_LIST_TOGGLE_LOADING:
      return {
        ...state,
        loading: action.data
      };
    default:
      return state
  }
};

/**
 * 前页跳转此页，需要传递参数：application.id、application.name
 */
export function redirectToApplicationMarketListPage(data) {
  return {
    type: REDIRECT_TO_APPLICATION_MARKET_LIST,
    data: data
  };
}

/**
 * update data based on user input
 */
export const updateApplicationMarketListData = (data) => {
  return {
    type: APPLICATION_MARKET_LIST_UPDATE_DATA,
    data: data
  }
};

/**
 * get parent categories
 */
export const getParentCategories = () => (dispatch) => {
  dispatch(toggleLoading(true));
  axios.get("/api-application/getApplicationCategoryByParentId?parentId=", {contentType: "application/json"}).then(
    response => {
      if (response.data) {
        dispatch(storeParentCategories(response.data));
        dispatch(toggleLoading(false));
      }
    }
  );
};

/**
 * store parent categories
 */
export const storeParentCategories = (parentCategories) => {
  return {
    type: APPLICATION_MARKET_LIST_STORE_PARENT_CATEGORIES,
    data: parentCategories
  }
};

/**
 * get second categories
 */
export const getSecondCategories = (data) => (dispatch) => {
  dispatch(toggleLoading(true));
  axios.get(`/api-application/getApplicationCategoryByParentId?parentId=${data.id}`, {contentType: "application/json"}).then(
    response => {
      if (response.data) {
        dispatch(storeSecondCategories(response.data));
        dispatch(toggleLoading(false));
      }
    }
  );
};

/**
 * store second categories
 */
export const storeSecondCategories = (secondCategories) => {
  return {
    type: APPLICATION_MARKET_LIST_STORE_SECOND_CATEGORIES,
    data: secondCategories
  }
};

/**
 * get applications
 */
export const getApplications = (data) => (dispatch) => {
  dispatch(toggleLoading(true));
  let params = `?name=${data.name}` +
    `&parentCategoryId=${data.parentCategory}` +
    `&categoryId=${data.secondCategory}` +
    `&minCost=${data.minCost}` +
    `&maxCost=${data.maxCost}` +
    `&releaseType=${data.releaseType}` +
    `&pageCurrent=${data.pageCurrent}` +
    `&pageSize=${data.pageSize}`;
  axios.get(`/api-application/searchApplicationByParams${params}`, {contentType: "application/json"}).then(
    response => {
      if (response.data) {
        dispatch(storeApplications(response.data.content));
        if (data.parentCategory) {
          dispatch(getSecondCategories({
            id: data.parentCategory
          }));
        }
        data.pageTotal = response.data.totalElements;
        dispatch(storePage(data));
        dispatch(toggleLoading(false));
      }
    }
  );
};

/**
 * store applications
 */
export const storeApplications = (applications) => {
  return {
    type: APPLICATION_MARKET_LIST_STORE_APPLICATIONS,
    data: applications
  }
};

/**
 * store page
 */
export const storePage = (page) => {
  return {
    type: APPLICATION_MARKET_LIST_STORE_PAGE,
    data: page
  }
};

/**
 * toggle loading
 */
export const toggleLoading = (show) => {
  return {
    type: APPLICATION_MARKET_LIST_TOGGLE_LOADING,
    data: show
  }
};
